import { getPlugin as getTranslationPlugin } from '@i18n/utils'

import translations from '../../components/TrustList/TrustList.translations'

export const warrantyItem = ({ warrantyDuration }) => {
  const $t = getTranslationPlugin()

  return {
    id: 'reassurance_service_warranty',
    text: $t(translations.warranty, {
      warrantyDuration,
    }),
    icon: 'IconFast',
  }
}
